// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__MFtpy","title":"AfterImages45_title__2rjvh","images":"AfterImages45_images__2QpWd"};